import type { SecondaryMarketPlatformFilter } from 'components/Blotters/SecondaryMarketTrade/filter/Filter.helper';
import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import { emptyBlotterPreferences } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterItem } from 'models/IBlotterItem';
import type {
  ActivityFilter,
  DateFilter,
  IBlotterColumnDefinition,
  SortDirection,
} from 'state/blotters/common/blotter.model';

export interface ISecondaryMarketTradeBlotterFilters {
  quickSearchTerm: string;
  dateFilter: DateFilter;
  activityFilter: ActivityFilter;
  platformFilter: SecondaryMarketPlatformFilter;
  advancedFilters: boolean;
  currencyFilter: string;
  customStartDateFilter?: Date;
  customEndDateFilter?: Date;
}

interface ISecondaryMarketTradeBlotter extends ISecondaryMarketTradeBlotterFilters {
  columnDefinition: IBlotterColumnDefinition<IBlotterItem>[];
  blotterPreferenceState: IBlotterPreferenceState;
  page: number;
  totalItems?: number;
  totalPages?: number;
  sort?: string;
  sortDir: SortDirection;
  loading: boolean;
  error?: string;
  items?: readonly IBlotterItem[];
  areBlotterPreferencesInError: boolean;
  canSaveBlotterPreferences: boolean;
}

export type SecondaryMarketTradeBlotterState = Readonly<ISecondaryMarketTradeBlotter>;

export const initialSecondaryMarketTradeBlotterFilters: ISecondaryMarketTradeBlotterFilters = {
  quickSearchTerm: '',
  activityFilter: 'mySelf',
  dateFilter: 'today',
  advancedFilters: false,
  currencyFilter: 'allCurrencies',
  platformFilter: 'AllPlatforms',
};
export const initialSecondaryMarketTradeBlotterState: SecondaryMarketTradeBlotterState = {
  page: 1,
  blotterPreferenceState: emptyBlotterPreferences,
  columnDefinition: [],
  sortDir: 'asc',
  loading: true,
  areBlotterPreferencesInError: false,
  canSaveBlotterPreferences: false,
  ...initialSecondaryMarketTradeBlotterFilters,
};
